import { buildPayloadApiUrl, payloadFetch } from "./client";
import { mapEntertainmentResponse } from "src/utils/mapEntertainment";

/**
 * Fetches entertainment hub cards from pg-payload-cms.
 * @param {string} locale - `en` | `fr`
 * @returns {Promise<import('src/utils/mapEntertainment').EntertainmentCard[]>}
 */
export async function fetchEntertainmentEvents(locale) {
  const url = buildPayloadApiUrl("/api/entertainment-events", {
    locale,
    limit: 200,
    depth: 1,
    sort: "_order",
  });

  const response = await payloadFetch(url);
  return mapEntertainmentResponse(response, locale);
}
